import axios from "axios";
import { ForgotPasswordPayload, LoginPayload, RegisterPayload, useAuthStore } from "../stores/authStore";
import { api } from "./api";
import { handleError } from "../utils/errors";

const auth = axios.create({
    // @ts-ignore
    baseURL: import.meta.env.VITE_SPA_URL,
    withCredentials: true, // required to handle the CSRF token
});

auth.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        if (error.response) {
            // Sesja wygasła
            if (error.response.status === 401 || error.response.status === 419) {
                // Tylko jeśli jesteśmy zalogowani
                if (useAuthStore().isGuest) {
                    return Promise.reject(error.response);
                }
                useAuthStore().logout();
            } else if (error.response.status === 503) {
                // Serwer jest niedostępny | Maintenance
                location.reload();
            }
        } else {
            handleError(error);
        }

        return Promise.reject(error.response);
    }
);

export const authService = {
    login: async (payload: LoginPayload) => {
        await auth.get("/sanctum/csrf-cookie");
        return auth.post("/login", payload);
    },
    register: async (payload: RegisterPayload) => {
        await auth.get("/sanctum/csrf-cookie");
        return auth.post("/register", payload);
    },
    forgotPassword: async (payload: ForgotPasswordPayload) => {
        await auth.get("/sanctum/csrf-cookie");
        return auth.post("/forgot-password", payload);
    },
    async resetPassword(payload) {
        await auth.get("/sanctum/csrf-cookie");
        return auth.post("/reset-password", payload);
    },
    logout: () => {
        return auth.post("/logout");
    },
    user: () => {
        return api.get("user");
    },
    sendVerificationNotification() {
        return auth.post("/email/verification-notification");
    },
    // passwordExpired(payload) {
    //     return api.post('/password-expired', payload)
    // }
};
